import 'css-chunk:src/cms/heroBanner/heroBanner.module.scss';export default {
  "heading-xxl": "heroBanner-module__heading-xxl___6spva",
  "wrapper": "heroBanner-module__wrapper___pe9Cd",
  "heading-xl": "heroBanner-module__heading-xl___HkBLW",
  "heading-lg": "heroBanner-module__heading-lg___ccO7V",
  "heading-md": "heroBanner-module__heading-md___R-KHo",
  "heading-sm": "heroBanner-module__heading-sm___0hPTW",
  "heading-xs": "heroBanner-module__heading-xs___b8iq-",
  "body-one": "heroBanner-module__body-one___YEacp",
  "body-two": "heroBanner-module__body-two___iIw2p",
  "body-three": "heroBanner-module__body-three___oPOjz",
  "body-four": "heroBanner-module__body-four___LJx5h",
  "overline-one": "heroBanner-module__overline-one___YutOe",
  "overline-two": "heroBanner-module__overline-two___wty2C",
  "overline-three": "heroBanner-module__overline-three___kDmr9",
  "strong": "heroBanner-module__strong___eKFD-",
  "em": "heroBanner-module__em___lMDv1",
  "figcaption": "heroBanner-module__figcaption___o4gIs",
  "no-margin": "heroBanner-module__no-margin___33eVB",
  "heroBanner": "heroBanner-module__heroBanner___5pIDa",
  "heroBannerWrapper": "heroBanner-module__heroBannerWrapper___fbwev",
  "heroBanner-withWideText": "heroBanner-module__heroBanner-withWideText___Xi8oR",
  "heroBannerTextContainer": "heroBanner-module__heroBannerTextContainer___tzp8S",
  "heroBannerMediaContainer": "heroBanner-module__heroBannerMediaContainer___m4-WF",
  "heroBannerAnnouncementBanner": "heroBanner-module__heroBannerAnnouncementBanner___C5QYP",
  "heroBannerContainer": "heroBanner-module__heroBannerContainer___c-pq-",
  "heroBannerPartnerContainer": "heroBanner-module__heroBannerPartnerContainer___-Zdcy",
  "heroBannerMediaImage": "heroBanner-module__heroBannerMediaImage___DdlXE",
  "hideImageOnSmallScreen": "heroBanner-module__hideImageOnSmallScreen___w0rG-"
};